<template>
    <div class="page">
        <!-- 顶部区域 - 蓝色渐变背景 -->
        <div class="ytop">
            <div class="ytop-bg-animation">
                <div class="circle circle-1"></div>
                <div class="circle circle-2"></div>
                <div class="circle circle-3"></div>
            </div>
            <div class="title">
                <div class="c-data">设备管理</div>
            </div>
            <div class="logo">
                <img src="@/assets/img/she/icon23.png">
                <div class="user-name">
                    <div class="name">{{ recordLoginText }}</div>
                    <div class="time">到期时间: {{ dataForm.expireTime }}</div>
                </div>
            </div>
            <div class="top-content">
                <div class="used">
                    <div class="used-total-num">{{ dataForm.totalData }}<span>GB</span></div>
                    <div class="used-total-CN">当前套餐总量</div>
                </div>
                <div class="used">
                    <div class="used-total-num">{{ dataForm.useDay }}<span>天</span></div>
                    <div class="used-total-CN">使用时长</div>
                </div>
                <div class="used">
                    <div class="used-total-num">{{ dataForm.remainDay }}<span>天</span></div>
                    <div class="used-total-CN">剩余时长</div>
                </div>
            </div>
        </div>

        <!-- 设备信息卡片 -->
        <div class="device">
            <div class="today">
                <img src="@/assets/img/she/icon_jrll.png" alt="">
                <div class="wifi">套餐用量</div>
                <div class="wifi-gb blue-text">{{ dataForm.useData }}<span>GB</span></div>
            </div>
            <div class="today">
                <img src="@/assets/img/she/icon_rdlj.png" alt="">
                <div class="wifi">热点连接</div>
                <div class="wifi-gb orange-text">{{ dataForm.deviceConnNum }}<span>设备</span></div>
            </div>
            <!-- deviceStatus 0 离线  1在线 -->
            <div class="device-state device-bg" v-if="dataForm.deviceStatus === '0'">
                <span class="status-dot offline-dot"></span>已离线
            </div>
            <div class="device-state device-bg1" v-if="dataForm.deviceStatus === '1'">
                <span class="status-dot online-dot"></span>在线
            </div>
            <div class="quantity">
                <div class="quantity-i">
                    <img v-if="battery * 1 === 0" src="@/assets/img/she/5.png" alt="">
                    <img v-if="battery * 1 > 0 && battery * 1 < 26" src="@/assets/img/she/6.png" alt="">
                    <img v-if="battery * 1 > 25 && battery * 1 < 51" src="@/assets/img/she/7.png" alt="">
                    <img v-if="battery * 1 > 50 && battery * 1 < 100" src="@/assets/img/she/8.png" alt="">
                    <img v-if="battery * 1 === 100" src="@/assets/img/she/9.png" alt="">
                </div>
                剩余电量
                <div class="quantity-n" v-if="battery * 1 === 0" style="padding-left:6px;"> {{ battery }}%</div>
                <div class="quantity-n" v-if="battery * 1 > 0 && battery * 1 < 26"
                    style="color:#e62307;padding-left:6px;">
                    {{ battery }}%</div>
                <div class="quantity-n" v-if="battery * 1 > 25 && battery * 1 < 51"
                    style="color:#FF8040;padding-left:6px;">
                    {{ battery }}%</div>
                <div class="quantity-n" v-if="battery * 1 > 50 && battery * 1 < 100"
                    style="color:#43CF7C;padding-left:6px;">
                    {{ battery }}%</div>
                <div class="quantity-n" v-if="battery * 1 === 100" style="color:#43CF7C;padding-left:6px;"> {{ battery
                    }}%</div>
            </div>
        </div>

        <!-- 功能按钮区 -->
        <div class="action-buttons">
            <!-- 隐藏WiFi功能暂未开放 -->
            <!-- <div class="action-btn hide-wifi-btn" @click="toggleWifiVisible">
                <div class="action-icon">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M1 1l22 22" />
                        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
                        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
                        <path d="M10.71 5.05A16 16 0 0 1 22.56 9" />
                        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
                        <path d="M8.53 10.9a5 5 0 0 1 6.95 6.95" />
                        <circle cx="12" cy="18" r="1" />
                    </svg>
                </div>
                <div class="action-text">
                    <div class="action-title">隐藏WiFi</div>
                    <div class="action-desc">当前: {{ dataForm.shildState === '1' ? '已隐藏' : '开放' }}</div>
                </div>
                <div class="toggle-switch">
                    <div class="toggle-track" :class="{ 'is-on': dataForm.shildState === '1' }">
                        <div class="toggle-thumb"></div>
                    </div>
                </div>
            </div> -->
            <div class="action-btn restart-btn" @click="handleRestart">
                <div class="action-icon">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="23 4 23 10 17 10" />
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
                    </svg>
                </div>
                <div class="action-text">
                    <div class="action-title">设备重启</div>
                    <div class="action-desc">重启设备恢复连接</div>
                </div>
                <div class="action-arrow">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="9 18 15 12 9 6" />
                    </svg>
                </div>
            </div>
        </div>

        <!-- 修改密码区 -->
        <div class="content-edit1">
            <div class="title-flex">
                <div class="big">修改密码</div>
                <div class="big-btn" @click="sureUpdatePass()">确认修改</div>
            </div>
            <div class="form-flex">
                <div class="label">热点名称:</div>
                <input class="value" placeholder="热点名称" v-model="dataForm.wifiName" />
            </div>
            <div class="form-flex">
                <div class="label">WIFI密码:</div>
                <input class="value" placeholder="WIFI密码" v-model="dataForm.wifiPwd" />
            </div>
        </div>

        <!-- 网络优选 -->
        <div class="content-edit1">
            <div class="title-flex">
                <div class="big">网络优选</div>
            </div>

            <div class="operator" @click="radioChange('1')" :class="[radio === '1' ? 'is-active' : '']"
                v-if="dataForm.sysMap && dataForm.sysMap.inIccid1 && dataForm.sysMap.inIccid1.length > 2">
                <img src="@/assets/img/she/icon_zgdx.png" alt="">
                <div class="operator-name">中国电信 ({{ in1AuthName }})</div>
                <div class="operator-state" v-if="radio === '1'">
                    <span class="pulse-dot"></span>正在使用
                </div>
            </div>

            <div class="operator" @click="radioChange('2')" :class="[radio === '2' ? 'is-active' : '']"
                v-if="dataForm.sysMap && dataForm.sysMap.inIccid2 && dataForm.sysMap.inIccid2.length > 2">
                <img src="@/assets/img/she/icon_zglt.png" alt="">
                <div class="operator-name">中国联通 ({{ in2AuthName }})</div>
                <div class="operator-state" v-if="radio === '2'">
                    <span class="pulse-dot"></span>正在使用
                </div>
            </div>

            <div class="operator" @click="radioChange('0')" :class="[radio === '0' ? 'is-active' : '']"
                v-if="dataForm.sysMap && dataForm.sysMap.outIccid && dataForm.sysMap.outIccid.length > 2">
                <img src="@/assets/img/she/icon_zgyd.png" alt="">
                <div class="operator-name">中国移动 ({{ outAuthName }})</div>
                <div class="operator-state" v-if="radio === '0'">
                    <span class="pulse-dot"></span>正在使用
                </div>
            </div>
        </div>

        <!-- 实名认证 -->
        <div class="content-edit1">
            <div class="title-flex">
                <div class="big">实名认证</div>
            </div>
            <div class="btn22" style="padding-top:12px;">
                <div class="b1" @click="toAllAuth(dataForm.sysMap.inIccid1)"
                    v-if="dataForm.sysMap && dataForm.sysMap.inIccid1 && dataForm.sysMap.inIccid1.length > 2">
                    <img src="@/assets/img/she/icon_zgdx.png" alt="">
                    电信实名
                </div>
                <div class="b1" @click="toAllAuth(dataForm.sysMap.inIccid2)"
                    v-if="dataForm.sysMap && dataForm.sysMap.inIccid2 && dataForm.sysMap.inIccid2.length > 2">
                    <img src="@/assets/img/she/icon_zglt.png" alt="">
                    联通实名
                </div>
                <div class="b1" @click="toAllAuth(dataForm.sysMap.outIccid)"
                    v-if="dataForm.sysMap && dataForm.sysMap.outIccid && dataForm.sysMap.outIccid.length > 2">
                    <img src="@/assets/img/she/icon_zgyd.png" alt="">
                    移动实名
                </div>
            </div>
        </div>

        <div class="footer-hi">温馨提示:</div>
        <div class="xsdw">1.修改设备后，页面数据将会有10-20分钟左右得延迟，并不影响您得使用。</div>
        <div class="xsdw">2.修改密码和切换网络后，需要等待10分钟重新把设备通电即可修改成功。</div>
        <div class="xsdw" style="padding-bottom:30px;">3.任何不懂可联系我们在线客服。</div>

        <van-dialog v-model="show" title="温馨提示" @confirm="confirm" @cancel="cancel" show-cancel-button
            confirmButtonText="确定切换" cancelButtonText="取消切换" confirmButtonColor="#2B6CB0" cancelButtonColor="#9e9e9e">
            <div class="el-tip">
                <div>1.切换网络前需要先实名切换的卡板，否则将会导致停机</div>
                <div>2.切换成功后，设备将会在10分钟后完成切换，请耐心等待</div>
                <div>3.信号灯绿色常亮表示切换完毕，如有其它疑问，可联系客服处理</div>
                <div>4.切换成功之后，系统将会自动退出 需要重新登录。</div>
            </div>
        </van-dialog>

        <!-- 隐藏WiFi确认弹窗 -->
        <van-dialog v-model="showShieldDialog" title="隐藏WiFi" @confirm="confirmShield" @cancel="cancelShield"
            show-cancel-button confirmButtonText="确定" cancelButtonText="取消" confirmButtonColor="#2B6CB0"
            cancelButtonColor="#9e9e9e">
            <div class="el-tip">
                <div>确定要{{ dataForm.shildState === '1' ? '开放' : '隐藏' }}WiFi吗？</div>
                <div v-if="dataForm.shildState !== '1'">隐藏后其他设备将搜索不到此WiFi，需手动输入名称连接</div>
                <div v-if="dataForm.shildState === '1'">开放后其他设备可以搜索到此WiFi</div>
            </div>
        </van-dialog>

        <!-- 设备重启确认弹窗 -->
        <van-dialog v-model="showRestartDialog" title="设备重启" @confirm="confirmRestart" @cancel="cancelRestart"
            show-cancel-button confirmButtonText="确定重启" cancelButtonText="取消" confirmButtonColor="#2B6CB0"
            cancelButtonColor="#9e9e9e">
            <div class="el-tip">
                <div>确定要重启设备吗？</div>
                <div>重启过程中设备将会断开连接，请耐心等待5~10分钟</div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { wxRequest } from "@/api/user";
import { Dialog } from "vant";
export default {
    data() {
        return {
            outAuthName: '',
            in1AuthName: '',
            in2AuthName: '',
            recordLoginText: localStorage.getItem("recordLoginText"),
            dataForm: {
                shildState: '0', //0隐藏 1开放
                sysMap: {},
            },
            show: false,
            showShieldDialog: false,
            showRestartDialog: false,
            wxHeadImg: localStorage.getItem("wxHeadImg"),
            radio: '',
            radioCopy: "",
            battery: '',
            iccid: localStorage.getItem("iccid"),
            xuniQie: '',
        }
    },
    created() {
        //  this.iccid = '8986062463007338095';
        // localStorage.setItem("iccid", "8986062463007338095")
        this.init()
    },
    watch: {
        radio(val, old) {
            this.radioCopy = old
        }
    },
    methods: {
        toAllAuth(iccid) {
            wxRequest("sim/detail", { iccid: iccid, shebeiAuth: 'yes' }, "post").then((res) => {
                if (res.data.code === '200') {
                    var flowRatePool = res.data.data.flowRatePool;
                    if (flowRatePool == "移动接口") {
                        wxRequest(
                            "wxAuth/cmcc/auth",
                            { iccid: iccid, isCheckout: "1s" },
                            "post"
                        ).then((res) => {
                            if (res.data.code == "200") {
                                window.location.href = res.data.data;
                            } else {
                                Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                });
                            }
                        });
                    } else if (flowRatePool == '移动') {
                        window.location.href = 'http://czlj.wzyw.cc/#/user/cmccAuthUrl?iccid=' + iccid + "&intoNo=" + res.data.data.intoNo;
                    } else if (flowRatePool == '联通') {
                        window.location.href = 'http://czlj.wzyw.cc/#/user/cuccAuthUrl?iccid=' + iccid
                    } else if (flowRatePool == '5G电信' || flowRatePool == '电信') {
                        wxRequest(
                            "wxAuth/ctcc/to/5G/auth",
                            { iccid: iccid, isCheckout: "sa" },
                            "post"
                        ).then((res) => {
                            if (res.data.code == "200") {
                                window.location.href = res.data.data;
                            } else {
                                Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                });
                            }
                        });
                    } else {
                        if (flowRatePool.indexOf("?") >= 0) {
                            window.location.href = flowRatePool + "&cn=" + iccid + "&iccid=" + iccid + "&cardno=" + iccid
                                + "&card_number=" + +localStorage.getItem('virtualNo');
                        } else {
                            window.location.href = flowRatePool + "?cn=" + iccid + "&iccid=" + localStorage.getItem('virtualNo') + "&cardno=" + iccid
                                + "&card_number=" + +localStorage.getItem('virtualNo');
                        }
                    }
                } else {
                    Toast.fail(res.data.message);
                }
            })
        },

        // 隐藏WiFi - 点击切换
        toggleWifiVisible() {
            this.showShieldDialog = true;
        },
        confirmShield() {
            // 切换状态: 当前隐藏(0)则开放(1)，当前开放(1)则隐藏(0)
            const newState = this.dataForm.shildState === '1' ? '0' : '1';
            this.toShiledShebei(newState);
        },
        cancelShield() {
            this.showShieldDialog = false;
        },
        // 设备重启 - 点击确认
        handleRestart() {
            this.showRestartDialog = true;
        },
        confirmRestart() {
            this.toRestartShebei();
        },
        cancelRestart() {
            this.showRestartDialog = false;
        },
        //0隐藏 1开放
        toShiledShebei(state) {
            wxRequest(
                "sim/shebei/sheildState",
                { iccid: this.dataForm.sysMap.vriNo, sheildState: state },
                "post"
            ).then((res) => {
                if (res.data.code == "200") {
                    this.dataForm.shildState = state;
                    Dialog.alert({
                        title: "操作成功",
                        message: state === '1' ? 'WiFi已开放，请等待10分钟后重新查看' : 'WiFi已隐藏，请等待10分钟后重新查看',
                    });
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            });
        },
        //设备重启按钮
        toRestartShebei() {
            wxRequest(
                "sim//shebei/restart",
                { iccid: this.dataForm.sysMap.vriNo },
                "post"
            ).then((res) => {
                if (res.data.code == "200") {
                    Dialog.alert({
                        title: "重启指令已发送",
                        message: "设备正在重启中，请耐心等待5~10分钟",
                    });
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            });
        },


        sureUpdatePass() {
            var data = {
                wifiName: this.dataForm.wifiName,
                wifiPwd: this.dataForm.wifiPwd,
                iccid: this.iccid
            }
            wxRequest("sim/update/shebei/pwd", data, "post").then(res => {
                if (res.data.code === '200') {
                    Dialog.alert({
                        title: '修改成功',
                        message: res.data.message
                    })

                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
        },
        init() {
            var data = {
                iccid: this.iccid
            }
            wxRequest("sim/get/shebei/info", data, "post").then(res => {
                if (res.data.code === '200') {
                    this.dataForm = res.data.data
                    this.radio = String(res.data.data.netState)
                    if (res.data.data.sysMap) {
                        this.outAuthName = res.data.data.sysMap.outAuthName;
                        this.in1AuthName = res.data.data.sysMap.in1AuthName;
                        this.in2AuthName = res.data.data.sysMap.in2AuthName;
                        this.battery = res.data.data.sysMap.battery;
                        this.xuniQie = res.data.data.sysMap.xuniQie;
                        if (this.xuniQie == 1) {
                            var xuniRadio = localStorage.getItem("xuniRadio");
                            if (xuniRadio) {
                                this.radio = xuniRadio;
                            } else {
                                this.radio = '';
                            }
                        }
                    }
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
        },
        radioChange(e) {
            this.radio = e
            this.show = true
        },
        cancel() {
            this.radio = this.radioCopy
            this.show = false
        },
        confirm() {
            if (this.radio == 1 && this.in1AuthName == '未实名') {
                Dialog.alert({
                    title: '实名提示',
                    message: '请先完成实名后再来进行切换操作，如已实名 请耐心等待5-10分钟完成实名同步'
                })
                return;
            }
            if (this.radio == 2 && this.in2AuthName == '未实名') {
                Dialog.alert({
                    title: '实名提示',
                    message: '请先完成实名后再来进行切换操作，如已实名 请耐心等待5-10分钟完成实名同步'
                })
                return;
            }
            if (this.radio == 0 && this.outAuthName == '未实名') {
                Dialog.alert({
                    title: '实名提示',
                    message: '请先完成实名后再来进行切换操作，如已实名 请耐心等待5-10分钟完成实名同步'
                })
                return;
            }
            if (this.xuniQie == 1) {
                localStorage.setItem("xuniRadio", this.radio)
                setTimeout(() => {
                    Dialog.alert({
                        title: '切换成功',
                        message: '切换成功，请等待10分钟后重新查看'
                    })
                }, 2000)
            } else {
                var data = {
                    iccid: this.iccid
                }
                if (this.radio == 1) {
                    data.cardSlot = this.dataForm.sysMap.in1Num
                    data.newIccid = this.dataForm.sysMap.inIccid1
                } else if (this.radio == 2) {
                    data.cardSlot = this.dataForm.sysMap.in2Num
                    data.newIccid = this.dataForm.sysMap.inIccid2
                } else if (this.radio == 0) {
                    data.cardSlot = this.dataForm.sysMap.outNum
                    data.newIccid = this.dataForm.sysMap.outIccid
                }
                wxRequest("sim/update/shebei/qie", data, "post").then(res => {
                    if (res.data.code === '200') {
                        Dialog.alert({
                            title: '切换成功',
                            message: res.data.message
                        })
                        localStorage.setItem("iccid", data.newIccid);
                        this.$store.state.iccid = data.newIccid;
                    } else {
                        Dialog.alert({
                            title: '温馨提示',
                            message: res.data.message
                        })
                    }
                })
            }


        },
        backPage() {
            let _this = this;
            if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
                _this.$router
                    .push({
                        path: "/userNew/home",
                        query: {
                            iccid: _this.$store.state.iccid,
                        },
                    })
                    .catch(() => { });
            } else {
                _this.$router
                    .push({
                        path: "/user/home",
                        query: {
                            iccid: _this.$store.state.iccid,
                        },
                    })
                    .catch(() => { });
            }
        }
    }
}
</script>

<style lang="less" scoped>
/* ===== 动画关键帧 ===== */
@keyframes floatCircle {

    0%,
    100% {
        margin-top: 0;
    }

    50% {
        margin-top: -10px;
    }
}

@keyframes onlinePulse {

    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(72, 187, 120, 0.5);
    }

    50% {
        box-shadow: 0 0 0 5px rgba(72, 187, 120, 0);
    }
}

.slide-up {}

.fade-in {}

.page {
    min-height: 100vh;
    background: linear-gradient(180deg, #E8F0FE 0%, #F0F4FA 30%, #F5F6F7 100%);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    text-rendering: optimizeLegibility;

    .ytop {
        position: relative;
        height: 280px;
        background: linear-gradient(135deg, #1A5DC7 0%, #2B7AE8 40%, #4A9AF5 100%);
        overflow: hidden;
        padding-bottom: 10px;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;

        .ytop-bg-animation {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            pointer-events: none;
        }

        .circle {
            position: absolute;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.06);
        }

        .circle-1 {
            width: 200px;
            height: 200px;
            top: -60px;
            right: -40px;
            animation: floatCircle 6s ease-in-out infinite;
        }

        .circle-2 {
            width: 120px;
            height: 120px;
            top: 80px;
            left: -30px;
            animation: floatCircle 8s ease-in-out infinite 2s;
        }

        .circle-3 {
            width: 80px;
            height: 80px;
            bottom: 40px;
            right: 30px;
            animation: floatCircle 5s ease-in-out infinite 1s;
        }

        .title {
            display: flex;
            height: 44px;
            align-items: center;
            position: relative;
            z-index: 1;

            .c-data {
                text-align: center;
                color: #fff;
                font-size: 18px;
                width: 100%;
                font-weight: 600;
                letter-spacing: 1px;
            }
        }

        .logo {
            margin-top: 14px;
            display: flex;
            align-items: center;
            position: relative;
            z-index: 1;

            img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                margin-left: 14px;
                margin-right: 14px;
                border: 2px solid rgba(255, 255, 255, 0.3);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }

            .user-name {
                width: calc(100% - 88px);
                color: #fff;

                .name {
                    font-size: 17px;
                    margin-bottom: 8px;
                    font-weight: 500;
                }

                .time {
                    font-size: 12px;
                    opacity: 0.85;
                }
            }
        }

        .top-content {
            height: 90px;
            border-radius: 14px;
            background: rgba(255, 255, 255, 0.2);
            display: flex;
            width: 90%;
            margin: 16px auto 0;
            align-items: center;
            justify-content: space-around;
            position: relative;
            z-index: 1;
            border: 1px solid rgba(255, 255, 255, 0.2);

            .used {
                text-align: center;
                position: relative;

                &:not(:last-child)::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    top: calc(50% - 15px);
                    width: 1px;
                    height: 30px;
                    background: rgba(255, 255, 255, 0.25);
                }

                .used-total-num {
                    font-size: 22px;
                    margin-bottom: 10px;
                    font-weight: 700;
                    color: #fff;

                    span {
                        font-size: 12px;
                        font-weight: 400;
                        opacity: 0.9;
                    }
                }

                .used-total-CN {
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }

    .device {
        margin: -20px auto 0;
        background: #fff;
        width: 90%;
        border-radius: 14px;
        position: relative;
        box-shadow: 0 4px 20px rgba(43, 122, 232, 0.1);
        padding-bottom: 10px;
        isolation: isolate;

        .today {
            display: flex;
            padding: 16px 18px;
            align-items: center;

            &:nth-child(2) {
                padding-top: 0;
            }

            .wifi {
                font-size: 14px;
                padding-left: 8px;
                padding-right: 12px;
                color: #555;
            }

            .wifi-gb {
                font-size: 20px;
                font-weight: 700;

                span {
                    color: #888;
                    font-size: 13px;
                    font-weight: 400;
                    padding-left: 4px;
                }
            }

            .blue-text {
                color: #2B7AE8;
            }

            .orange-text {
                color: #F5A623;
            }
        }

        .device-state {
            font-size: 12px;
            position: absolute;
            right: 0;
            width: auto;
            min-width: 72px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            top: 32px;
            padding: 0 12px 0 8px;
            border-radius: 14px 0 0 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
        }

        .device-bg {
            color: #999;
            background: #F0F0F0;
        }

        .device-bg1 {
            color: #48BB78;
            background: #F0FFF4;
            animation: onlinePulse 2s ease-in-out infinite;
        }

        .status-dot {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
        }

        .online-dot {
            background: #48BB78;
            box-shadow: 0 0 6px rgba(72, 184, 120, 0.6);
        }

        .offline-dot {
            background: #999;
        }
    }

    .quantity {
        background: #fff;
        padding: 8px 18px 12px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666;

        img {
            width: 26px;
            height: 26px;
            margin-right: 16px;
        }
    }

    /* ===== 功能按钮区 ===== */
    .action-buttons {
        width: 90%;
        margin: 14px auto;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .action-btn {
            display: flex;
            align-items: center;
            background: #fff;
            border-radius: 14px;
            padding: 14px 16px;
            box-shadow: 0 2px 12px rgba(43, 122, 232, 0.08);
        }

        .action-icon {
            width: 42px;
            height: 42px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            flex-shrink: 0;
        }

        .hide-wifi-btn {
            .action-icon {
                background: linear-gradient(135deg, #EBF4FF, #D6E4FF);
                color: #2B7AE8;
            }
        }

        .restart-btn {
            .action-icon {
                background: linear-gradient(135deg, #FFF5EB, #FFE4C6);
                color: #F5A623;
            }
        }

        .action-text {
            flex: 1;

            .action-title {
                font-size: 15px;
                font-weight: 600;
                color: #333;
                margin-bottom: 2px;
            }

            .action-desc {
                font-size: 12px;
                color: #999;
            }
        }

        .action-arrow {
            color: #CCC;
            flex-shrink: 0;
        }

        .toggle-switch {
            flex-shrink: 0;
        }

        .toggle-track {
            width: 46px;
            height: 26px;
            border-radius: 13px;
            background: #E0E0E0;
            position: relative;
            transition: background 0.3s ease;

            &.is-on {
                background: #2B7AE8;
            }
        }

        .toggle-thumb {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: #fff;
            position: absolute;
            top: 2px;
            left: 2px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
            transition: left 0.25s ease;

            .is-on & {
                left: 22px;
            }
        }
    }

    .content-edit1 {
        width: 90%;
        margin: 14px auto;
        background: #fff;
        padding: 18px 0;
        border-radius: 14px;
        box-shadow: 0 2px 12px rgba(43, 122, 232, 0.08);

        .title-flex {
            display: flex;
            padding: 0 15px;
            justify-content: space-between;

            .big {
                font-size: 16px;
                font-weight: 600;
                position: relative;
                margin-left: 12px;
                color: #333;

                &::before {
                    content: '';
                    height: 16px;
                    left: -12px;
                    width: 3px;
                    background: linear-gradient(180deg, #2B7AE8, #4A9AF5);
                    border-radius: 2px;
                    position: absolute;
                }
            }

            .big-btn {
                background: linear-gradient(135deg, #2B7AE8, #4A9AF5);
                border-radius: 14px;
                width: 74px;
                height: 28px;
                text-align: center;
                font-size: 13px;
                color: #fff;
                line-height: 28px;
                box-shadow: 0 2px 8px rgba(43, 122, 232, 0.3);

                &:active {
                    opacity: 0.85;
                }
            }
        }

        .btn22 {
            justify-content: space-between;
            display: flex;
            width: 100%;
            align-items: stretch;
            margin: 0 auto;
            padding: 0 16px;
            box-sizing: border-box;
            gap: 10px;

            .b1 {
                text-align: center;
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                border: none;
                border-radius: 12px;
                margin-left: 0;
                font-size: 12px;
                color: #2B7AE8;
                background: #F0F5FF;
                padding: 12px 6px;
                transition: all 0.3s ease;
                -webkit-tap-highlight-color: transparent;
                min-width: 0;
                box-sizing: border-box;

                &:active {
                    background: #DBE5FF;
                }

                img {
                    width: 24px;
                    height: 24px;
                    display: block;
                    margin: 0 auto 6px;
                }
            }
        }

        .form-flex {
            margin: 0 16px;
            background: #F5F7FA;
            height: 48px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            margin-top: 12px;
            transition: all 0.3s ease;

            &:focus-within {
                background: #EBF2FF;
                box-shadow: 0 0 0 2px rgba(43, 122, 232, 0.15);
            }

            .label {
                width: 30%;
                text-align: center;
                font-size: 14px;
                color: #555;
                font-weight: 500;
            }

            .value {
                background: none;
                width: 70%;
                font-size: 14px;
                color: #333;
                border: none;
                outline: none;
            }
        }

        .operator {
            height: 54px;
            border-radius: 12px;
            border: 1px solid #EEF2F7;
            background: #F8FAFC;
            margin: 0 16px;
            margin-top: 12px;
            display: flex;
            position: relative;
            align-items: center;

            &:active {
                opacity: 0.75;
            }

            img {
                margin: 0 14px;
            }

            .operator-name {
                font-size: 15px;
                margin-right: 10px;
                color: #333;
            }

            .operator-type {
                font-size: 12px;
                text-align: center;
                height: 16px;
                width: 50px;
                line-height: 16px;
                color: #fff;
            }

            .operator-type-seccess {
                background: url('../../assets/img/she/bg_ysm.png') no-repeat center;
                background-size: 100% 100%;
            }

            .operator-type-waring {
                background: url('../../assets/img/she/icon_wsm.png') no-repeat center;
                background-size: 100% 100%;
            }

            .operator-state {
                color: #2B7AE8;
                font-size: 12px;
                position: absolute;
                right: 14px;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 4px;
            }

            .pulse-dot {
                display: inline-block;
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background: #2B7AE8;
            }
        }

        .is-active {
            background: linear-gradient(135deg, #EBF4FF, #DBEAFE) !important;
            border-color: rgba(43, 122, 232, 0.3) !important;
            box-shadow: 0 2px 12px rgba(43, 122, 232, 0.15);
        }
    }

    .footer-hi {
        font-size: 13px;
        color: #888;
        font-weight: 500;
        width: 90%;
        margin: 18px auto 10px auto;
    }

    .xsdw {
        color: #999;
        font-size: 12px;
        width: 90%;
        margin: 0 auto 10px auto;
        line-height: 20px;
    }
}

.el-tip {
    padding: 16px;
    line-height: 1.8;
    color: #333;
    font-size: 14px;
}
</style>